import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col, Container } from "react-bootstrap";
import TableList from "./TableList";
import { getSuvicharApi, getTeamApi } from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import moment from "moment";
import NoDataFound from "../../../components/shared/Loader/NoDataAnimation";
import { BiPlusCircle } from "react-icons/bi";
import AddEdit from "./AddEdit";
import ODatePicker from "../../../components/shared/datePicker/ODatePicker";
import Pagination from "../../../components/shared/pagination";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import { useNavigate } from "react-router-dom";

const SuvicharManager = () => {
  const notification = useToastContext();
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");
  // ALL STATE
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [user, setUser] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [modalType, setModalType] = useState("");
  const [currentActiveData, setCurrentActiveData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchedGetUsers();
  }, []);

  const fetchedGetUsers = (data = {}) => {
    const requestPayload = {
      ...data,
      page: currentPage,
      pageSize: rowsPerPage,
    };
    getSuvicharApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setUser(response?.docs || []);
        setTotalPages(response?.totalDocs);
      }
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEndDateFilterChange = (dateArray) => {
    const date = Array.isArray(dateArray) ? dateArray.join("-") : dateArray; // Convert array to string
    setFilterData((prev) => ({
      ...prev,
      endDate: date ? date : null,
    }));
  };

  const handleStartDataFilterChange = (dateArray) => {
    const date = Array.isArray(dateArray) ? dateArray.join("-") : dateArray; // Convert array to string
    setFilterData((prev) => ({
      ...prev,
      startDate: date ? date : null,
    }));
  };

  const handleResetFilter = () => {
    setFilterData({});
    fetchedGetUsers();
  };

  // Handle apply filter action
  const handleApplyFilter = () => {
    const trimmedFilterData = {
      ...filterData,
      keyword: filterData.keyword ? filterData.keyword.trim() : "",
    };
    fetchedGetUsers(trimmedFilterData);
  };

  const handleShowModal = (type, data) => {
    setShow(!show);
    setModalType(type);
    if (type == "edit") {
      setCurrentActiveData(data);
    }
  };

  useEffect(() => {
    if (currentPage && rowsPerPage) {
      fetchedGetUsers();
    }
  }, [currentPage, rowsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (rows) => {
    setRowsPerPage(rows);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      }
    } else {
      navigate("/");
    }
  }, [Token]);

  return (
    <div className="right-panel p-3">
      <div class="common-heading text-start mb-3">
        <h4 className="mb-3 fw-bold fs-5 ">Suvichar Manager </h4>
      </div>

      <div className="bg-white border text-start p-3 mb-4">
        <Row className="align-items-center gx-2">
          <Col lg={3} md={4}>
            <Form.Control
              type="text"
              placeholder="Search..."
              name="keyword"
              value={filterData.keyword || ""}
              onChange={handleFilterChange}
            />
          </Col>
          <Col lg={3} md={4} xs={6} className="mt-md-0 mt-2">
            <ODatePicker
              name="startDate"
              value={filterData?.startDate && new Date(filterData.startDate)}
              placeholder={"Start Date"}
              onChange={handleStartDataFilterChange}
              className="form-control"
              maxDate={new Date()}
            />
          </Col>
          <Col lg={3} md={4} xs={6} className="mt-md-0 mt-2">
            <ODatePicker
              name="endDate"
              value={filterData?.endDate && new Date(filterData.endDate)}
              placeholder={"End Date"}
              onChange={handleEndDateFilterChange}
              className="form-control"
              maxDate={new Date()}
            />
          </Col>
          <Col lg={3} md={4} className="mt-lg-0 mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  type="button"
                  className="bg-orange border-0 me-2 normal-size"
                  onClick={handleApplyFilter}
                >
                  Filter
                </Button>
                <Button
                  type="button"
                  className="bg-orange border-0 normal-size me-2"
                  onClick={handleResetFilter}
                >
                  Reset
                </Button>
              </div>
              <Button
                type="button"
                onClick={() => handleShowModal("add")}
                className="bg-black btn text-white border-0 normal-size"
              >
                Add <BiPlusCircle />
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loader ? (
        <Container className="d-flex justify-content-center align-items-center default-back">
          <span>
            <LottiLoader height={120} width={120} loader={true} />
          </span>
        </Container>
      ) : (
        <>
          {user && user?.length > 0 && (
            <TableList
              handleShowModal={handleShowModal}
              userData={user}
              setUser={setUser}
              fetchedGetUsers={fetchedGetUsers}
              pageLoader={loader}
            />
          )}
        </>
      )}
      {!loader && user?.length > 0 && (
        <div className="flex w-full align-center justify-center">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </div>
      )}

      {!loader && user?.length == 0 && (
        <NoDataFound
          height={200}
          width={200}
          firstMessage="No Suvichar found."
        />
      )}
      {show && (
        <AddEdit
          show={show}
          onHide={handleShowModal}
          modalType={modalType}
          currentActiveData={currentActiveData}
          fetchedGetUsers={fetchedGetUsers}
          setCurrentActiveData={setCurrentActiveData}
        />
      )}
    </div>
  );
};

export default SuvicharManager;
